var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'general-warning ' + _vm.status},[_c('alert-icon',{staticStyle:{"font-size":"0.8em","margin-bottom":"2px"},attrs:{"title":""}}),_c('p',[_vm._v(_vm._s(_vm.warning))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }